import * as React from 'react';

function FontIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M16.0024 7.50006C15.6676 7.50006 15.3852 7.25074 15.3436 6.9185L14.9997 4.16673H10.833V15.8334L12.7675 16.1558C13.0938 16.2102 13.333 16.4925 13.333 16.8233C13.333 17.1971 13.03 17.5001 12.6563 17.5001H7.34307C6.96932 17.5001 6.66634 17.1971 6.66634 16.8233C6.66634 16.4925 6.90551 16.2102 7.23181 16.1558L9.16634 15.8334V4.16673L4.99967 4.16673L4.6557 6.9185C4.61417 7.25074 4.33174 7.50006 3.99692 7.50006C3.63025 7.50006 3.33301 7.20282 3.33301 6.83615V3.33339C3.33301 2.87316 3.7061 2.50006 4.16634 2.50006H15.833C16.2932 2.50006 16.6663 2.87316 16.6663 3.33339V6.83615C16.6663 7.20282 16.3691 7.50006 16.0024 7.50006Z"
        className="fill-icn-txt-prim"
      />
    </svg>
  );
}

export default FontIcon;
